var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._g(
      {
        attrs: { id: "diagram-div" },
        on: {
          "update-layout": _vm.diagramUpdated,
          "click-breaker": _vm.breakerClick,
        },
      },
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }